import React from "react";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-light pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row">
          {/* Company Info */}
          <div className="col-md-3 mb-4">
            <h5 className="text-uppercase fw-bold text-primary">PTC</h5>
            <p>
              Ptrans And Controls (PTC) is a leader in industrial automation
              solutions, delivering high-quality instrumentation and control
              systems for multiple industries.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4">
            <h6 className="text-uppercase fw-bold">Quick Links</h6>
            <ul className="list-unstyled">
              <li><a href="#" className="text-light text-decoration-none">Home</a></li>
              <li><a href="#" className="text-light text-decoration-none">Products</a></li>
              <li><a href="#" className="text-light text-decoration-none">Solutions</a></li>
              <li><a href="#" className="text-light text-decoration-none">Industry</a></li>
              <li><a href="#" className="text-light text-decoration-none">Careers</a></li>
              <li><a href="#" className="text-light text-decoration-none">Contact</a></li>
            </ul>
          </div>

          {/* Products */}
          <div className="col-md-3 mb-4">
            <h6 className="text-uppercase fw-bold">Products</h6>
            <ul className="list-unstyled">
              <li><a href="#" className="text-light text-decoration-none">Flow Meters</a></li>
              <li><a href="#" className="text-light text-decoration-none">Pressure Sensors</a></li>
              <li><a href="#" className="text-light text-decoration-none">Level Indicators</a></li>
              <li><a href="#" className="text-light text-decoration-none">LED Displays</a></li>
              <li><a href="#" className="text-light text-decoration-none">Data Loggers</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-3 mb-4">
            <h6 className="text-uppercase fw-bold">Contact Us</h6>
            <p>
              <i className="bi bi-geo-alt-fill"></i> Survey No 47, Plot No. 5,
              Jambhulwadi Road, near Mudra Hotel, Lipane Nagar, Kolewadi, Pune,
              Maharashtra 411046 (India)
            </p>
            <p>
              <i className="bi bi-telephone-fill"></i> +91-8329287300
            </p>
            <p>
              <i className="bi bi-envelope-fill"></i> ptransandcontrols@gmail.com
            </p>

            {/* Social Media Icons */}
            <div className="d-flex mt-3">
              <a href="#" className="me-3 text-light"><i className="bi bi-facebook fs-4"></i></a>
              <a href="#" className="me-3 text-light"><i className="bi bi-linkedin fs-4"></i></a>
              <a href="#" className="me-3 text-light"><i className="bi bi-twitter fs-4"></i></a>
              <a href="#" className="text-light"><i className="bi bi-instagram fs-4"></i></a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="row mt-4">
          <div className="col text-center">
            <p className="mb-0">
              &copy; 2025 <strong>PTC - Ptrans And Controls</strong>. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
